<div class="footer">
  <div class="container-fluid">
    <span>© Broadridge Financial Solutions</span>
    <span *ngIf='currentUser?.selectedClient'>
      Client: {{currentUser.selectedClient.clientName}}
    </span>
    <span>UI Version 1.1.0</span>
  </div>
</div>
